import { ChartStyleConfigs } from '../../../multi-stage-growth-report/constants/multi-stage-growth-report.constant';
import { Colors } from '../../../shared/models/common.model';

export enum PlacementLevelCode {
  DNM = 'DNM',
  APP = 'APP',
  MET = 'MET',
  EXC = 'EXC',
}

export enum ArrowPosition {
  UP = 'up',
  DOWN = 'down',
  DASH = 'dash',
}

export enum ArrowName {
  UP = 'arrow-up',
  DOWN = 'arrow-down',
}

export enum PlacementLevelValues {
  DNM = 'domain-summary.domain-summary-graph.placement-level-values.does-not-meet',
  APP = 'domain-summary.domain-summary-graph.placement-level-values.approaching',
  MET = 'domain-summary.domain-summary-graph.placement-level-values.meets',
  EXC = 'domain-summary.domain-summary-graph.placement-level-values.exceeds',
}

export enum LegendIndicatorClass {
  DNM = 'does-not-meet-indicator',
  APP = 'approaching-indicator',
  MET = 'meets-indicator',
  EXC = 'exceeds-indicator',
}

export enum StudentNumberClass {
  ZeroStudentClass = 'zero-student-class',
}

export enum LegendIndicatorScore {
  DNM = 'domain-summary.does-not-meet-score-indicator',
  APP = 'domain-summary.approaching-score-indicator',
  MET = 'domain-summary.meets-score-indicator',
  EXC = 'domain-summary.exceeds-score-indicator',
}

export const DEFAULT_MULTI_PART_PROGRESS_BAR_ITEMS = [
  {
    id: PlacementLevelCode.DNM,
    percentage: 0,
    label: '0',
    fillColor: Colors.CUSTOM,
    customFillColor: Colors.RED,
    customFontColor: Colors.RED_TEXT,
    customHoverColor: Colors.RED_HOVER,
  },
  {
    id: PlacementLevelCode.APP,
    percentage: 0,
    label: '0',
    fillColor: Colors.CUSTOM,
    customFillColor: Colors.YELLOW,
    customFontColor: Colors.YELLOW_TEXT,
    customHoverColor: Colors.YELLOW_HOVER,
  },
  {
    id: PlacementLevelCode.MET,
    percentage: 0,
    label: '0',
    fillColor: Colors.CUSTOM,
    customFillColor: Colors.GREEN,
    customFontColor: Colors.GREEN_TEXT,
    customHoverColor: Colors.GREEN_HOVER,
  },
  {
    id: PlacementLevelCode.EXC,
    percentage: 0,
    label: '0',
    fillColor: Colors.CUSTOM,
    customFillColor: Colors.BLUE,
    customFontColor: Colors.BLUE_TEXT,
    customHoverColor: Colors.BLUE_HOVER,
  },
];

export const OV_DOMAIN = 'OV';

export const DEFAULT_COLUMN_CHART_STYLE_CONFIG = {
  xAxis: {
    fontColor: ChartStyleConfigs.X_AXIS_FONT_COLOR,
    fontFamily: ChartStyleConfigs.X_AXIS_FONT_FAMILY,
    fontSize: ChartStyleConfigs.X_AXIS_FONT_SIZE,
    fontWeight: ChartStyleConfigs.X_AXIS_FONT_WEIGHT,
    lineHeight: ChartStyleConfigs.X_AXIS_LINE_HEIGHT,
  },
  yAxis: {
    titleStyle: {
      fontColor: ChartStyleConfigs.Y_AXIS_FONT_COLOR,
      fontFamily: ChartStyleConfigs.Y_AXIS_FONT_FAMILY,
      fontSize: ChartStyleConfigs.Y_AXIS_FONT_SIZE_LARGE,
      fontWeight: ChartStyleConfigs.Y_AXIS_FONT_WEIGHT_SEMI_BOLD,
      lineHeight: ChartStyleConfigs.Y_AXIS_LINE_HEIGHT,
    },
    labelStyle: {
      fontColor: ChartStyleConfigs.Y_AXIS_FONT_COLOR,
      fontFamily: ChartStyleConfigs.Y_AXIS_FONT_FAMILY,
      fontSize: ChartStyleConfigs.Y_AXIS_FONT_SIZE_MEDIUM,
      fontWeight: ChartStyleConfigs.Y_AXIS_FONT_WEIGHT_SEMI_BOLD,
      lineHeight: ChartStyleConfigs.Y_AXIS_LINE_HEIGHT,
    },
  },
  width: null,
  showAnimation: false,
  margin: [30, 50, 56, 60],
  columnColor: [Colors.RED, Colors.YELLOW, Colors.GREEN, Colors.BLUE],
};
